import { forEach, cloneDeep, set, filter, get } from 'lodash';
import {
  ADD_SERVICE,
  DELETE_SERVICE,
  UPDATE_SERVICE,
} from '../../services/constants';
import {
  UPDATE_SHOP,
} from '../../shops/constants';

const deleteService = (state, serviceId) => {
  const newState = cloneDeep(state);
  forEach(state, (value, key) => {
    const services = get(value, 'services', []);
    set(newState, `${key}.services`, filter(services, item => item !== serviceId));
  });
  return newState;
};

const addService = (state, action) => {
  const newState = cloneDeep(state);
  (action.data.barbers || []).forEach((barberId) => {
    const services = get(newState, `${barberId}.services`, []);
    set(newState, `${barberId}.services`, [...services, action.response.result]);
  });
  return newState;
};

const byId = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_SERVICE:
      return addService(
        deleteService(state, action.response.result),
        action
      );
    case ADD_SERVICE:
      return addService(state, action);
    case DELETE_SERVICE:
      return deleteService(state, action.serviceId);
    case UPDATE_SHOP:
      return state;
    default:
      break;
  }

  if (action.response) {
    const { barbers } = action.response.entities || {};
    return {
      ...state,
      ...(barbers || {}),
    };
  }

  return state;
};

export default byId;
